import { render, staticRenderFns } from "./sample.vue?vue&type=template&id=6b892bcc&scoped=true"
import script from "./sample.vue?vue&type=script&lang=js"
export * from "./sample.vue?vue&type=script&lang=js"
import style0 from "./sample.vue?vue&type=style&index=0&id=6b892bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b892bcc",
  null
  
)

export default component.exports